import { memo, useEffect } from "react";
import { SpecialOfferApiEnums } from "@rshbintech.dboul/http";
import {
  DocumentDisplay,
  HeaderDisplay,
  MainPageDisplay,
  TabDisplay,
} from "../types";
import {
  AnalyticsCategoryName,
  sendAnalytics,
} from "../../common/utils/send-analytics";
import { getSpecialOfferAnalyticsId } from "../utils";
import { SpecialOfferCard } from "./components/card";
import { SpecialOfferHeader } from "./components/header";
import { SpecialOfferTab } from "./components/tab";
import { SpecialOfferComponentProps } from "./types";
import { ANALYTICS_ACTION_TYPES } from "./constants";

export const SpecialOfferComponent = memo(
  ({
    type,
    data,
    analyticsActionName,
    clientInn,
    dataTestId,
    onClick,
  }: SpecialOfferComponentProps) => {
    const analyticsId = getSpecialOfferAnalyticsId({
      id: data?.id,
      ...data?.landingSettings,
    });

    useEffect(() => {
      if (analyticsActionName && analyticsId) {
        sendAnalytics({
          eventCategoryName: AnalyticsCategoryName.SPECIAL_OFFER,
          eventActionName: analyticsActionName + ANALYTICS_ACTION_TYPES.SHOW,
          eventValueText: analyticsId,
          inn: clientInn,
        });
      }
    }, [analyticsActionName, analyticsId]);

    const handleSpecialOfferComponentClick = () => {
      if (analyticsActionName) {
        sendAnalytics({
          eventCategoryName: AnalyticsCategoryName.SPECIAL_OFFER,
          eventActionName: analyticsActionName + ANALYTICS_ACTION_TYPES.CLICK,
          eventValueText: analyticsId,
          inn: clientInn,
        });
      }

      onClick();
    };

    switch (type) {
      case SpecialOfferApiEnums.SpecialOfferTypeEnum.MAIN_PAGE:
        return (
          <SpecialOfferCard
            settings={data?.mainPageDisplay?.listDisplay as MainPageDisplay}
            onClick={handleSpecialOfferComponentClick}
            dataTestId={dataTestId}
          />
        );

      case SpecialOfferApiEnums.SpecialOfferTypeEnum.DOCUMENT:
        return (
          <SpecialOfferCard
            settings={data.documentDisplay as DocumentDisplay}
            onClick={handleSpecialOfferComponentClick}
            dataTestId={dataTestId}
          />
        );

      case SpecialOfferApiEnums.SpecialOfferTypeEnum.HEADER:
        return (
          <SpecialOfferHeader
            settings={data.menuHeaderDisplay as HeaderDisplay}
            onClick={handleSpecialOfferComponentClick}
            dataTestId={dataTestId}
          />
        );

      case SpecialOfferApiEnums.SpecialOfferTypeEnum.TAB:
        return (
          <SpecialOfferTab
            settings={data.tabDisplay as TabDisplay}
            onClick={handleSpecialOfferComponentClick}
            dataTestId={dataTestId}
          />
        );

      default:
        return null;
    }
  }
);
